export default {
    primaryText: "#555555",
    secondaryText: "#aaaaaa",
    unimportantText: "#cccccc",
    disabledButtonText: "#bfbfbf",
    disabledButtonBackground: "#e0e0e0",
    lightBackgorund: "#eaeaea",
    accent: "#eb4a42",
    white: "#ffffff"
};



/** WEBPACK FOOTER **
 ** ./app/lib/colors.js
 **/